import { Pipe, PipeTransform, Inject, LOCALE_ID } from '@angular/core';

import { isNil } from 'lodash-es';
import { DecimalPipe } from '@angular/common';
/*
 * If count is over 100,000
 * returns 'Over 100,000' records
 * If less, returns actual number.
 */
@Pipe({name: 'limitedCountToText'})
export class LimitedCountToTextPipe implements PipeTransform {
  private readonly _decimalPipe;
  /**
   *
   */
  constructor(@Inject(LOCALE_ID) private _locale: string) {
    this._decimalPipe = new DecimalPipe(_locale);
  }

  transform(value: number): string {
    if (isNil(value)) {
      return '';
    }

    if (value === 100000) {
      return '100,000+';
    }

    return this._decimalPipe.transform(value);
  }
}
